import { Box, Grid, GridItem, Img, Text } from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import Interaction from './Interaction';
import { ProfileContext } from '../EntirePreview';
import { motion } from 'framer-motion';
import { API_SERVER } from 'config/constant';
import { ScoreContext } from '../GamePreview';
import 'assets/css/CustomScroll.css';
import ReplayGame from './ReplayGame';
import Scrollbar from 'components/customScroll/CustomScroll';
import { useParams } from 'react-router-dom';
import LoadImg from 'assets/gif/SpartanGif.gif';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducers';
const Story: React.FC<{
  imageSrc?: any;
  replayGame: any;
  isOptionalReplay: any;
  setisOptionalReplay: any;
  profilescore: any;
  setisReplay: any;
  isReplay: any;
  setType: any;
  setData: any;
  replayNextHandler: any;
  prevData?: any;
  currentScore?: any;
  data?: any;
  type?: any;
  profileData: any;
  getData: any;
  option: any;
  options: any;
  handleValidate: any;
  resMsg: any;
  feed: any;
  setIsGetsPlayAudioConfirmation: any;
  formData: any;
  setAudioObj: any;
  selectedPlayer: any;
  selectedNpc: any;
  voiceIds: any;
  setIsPrevNavigation: any;
  setNavTrack: any;
  navTrack: any;
  gameInfo: any;
  preloadedAssets: any;
  questState: any;
  LastModiPrevData: any;
  setPreLogDatas: any;
  getPrevLogDatas: any;
  RepeatSelectOption: any;
  RepeatPrevOption: any;
  optio?: any;
  Player: React.FC;
  ModelPlayer: React.FC;
  setScore: any;
  SetAudioOptions: any;
  score: any;
  AudioOptions: any;
  upComingBlockChoosen?: any;
  setFeedbackList: any;
  feedbackList: any;
  isScreenshot: any;
  currentScreenId: any;
  setModalLoaded: any;
  modalLoaded: any;
  SetGlbPlayingDetails: any;
  setIsZoomComplete: any;
  isZoomComplete: any;
  setNonPlayerNameLanguage: any;
  NonPlayerNameLanguage: any;
}> = ({
  data,
  type,
  resMsg,
  feed,
  getData,
  profileData,
  option,
  options,
  setAudioObj,
  handleValidate,
  formData,
  selectedPlayer,
  setIsGetsPlayAudioConfirmation,
  setIsPrevNavigation,
  setNavTrack,
  navTrack,
  gameInfo,
  preloadedAssets,
  replayGame,
  replayNextHandler,
  setisReplay,
  setisOptionalReplay,
  isOptionalReplay,
  profilescore,
  setData,
  setType,
  isReplay,
  questState,
  LastModiPrevData,
  getPrevLogDatas,
  setPreLogDatas,
  RepeatSelectOption,
  RepeatPrevOption,
  setScore,
  SetAudioOptions,
  score,
  AudioOptions,
  upComingBlockChoosen,
  modalLoaded,
  SetGlbPlayingDetails,
  isZoomComplete,
  setNonPlayerNameLanguage,
  NonPlayerNameLanguage,
}) => {
  const previewStateData = useSelector((state: RootState) =>
    formData?.gameId && state.preview ? state.preview[formData?.gameId] : null,
  );
  console.log(data,'datainstorypr')
  const [showNote, setShowNote] = useState(true),
    [first, setFirst] = useState(false);
  const { profile, setProfile } = useContext(ScoreContext);
  const [showTypingEffect, setShowTypingEffect] = useState<any>(false);
  const [interactionNext, setInteractionNext] = useState(null);
  const [optionalReplay, setOptionalReplay] = useState(false);
  const [contentByLanguage, setContentByLanguage] = useState(null);
  const EnumType = {
    BGM: 'bgm',
    VOICE: 'voice',
  };
  const [animateNote, setAnimateNote] = useState<boolean>(false);
  const [animateDialog, setAnimateDialog] = useState<boolean>(false);
  const [animateInteraction, setAnimateInteraction] = useState<boolean>(false);
  const [animateFeedback, setAnimateFeedback] = useState<boolean>(false);
  const [showGLB, setShowGLB] = useState<boolean>(false);
  const [basedOnNDI, setBasedOnNDI] = useState<any>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { id } = useParams();
  const Gameid = id ? id : null;
  useEffect(() => {
    if (modalLoaded) {
      setTimeout(() => {
        setIsLoading(false); // Set the loader to false after the operation is complete
      }, 2500); // Assume a 3-second load time
    } else {
      setIsLoading(true);
    }
  }, [modalLoaded]);
  useEffect(() => {
    if (data && type) {
      setAudioObj((prev: any) => ({
        ...prev,
        url: '',
        type: EnumType.VOICE,
        loop: false, // Voice doesn't loop
        autoplay: true, // Autoplay is disabled
      }));
      setAnimateInteraction(false);
      setShowNote(true);
      setShowTypingEffect(false);
      setTimeout(() => {
        setShowNote(false);
        interactionNext === true && setInteractionNext(false);
      }, 1000);
      if (type === 'Note' || type === 'Dialog' || type === 'Interaction') {
        SetAudioOptions({ qpOptionId: '' });
      }
      if (profileData?.Audiogetlanguage.length !== 0) {
        const GameLanguageFilter = profileData?.Audiogetlanguage.filter(
          (key: any) => key?.textId === formData?.gameId,
        );
        const BlockTextFilter = profileData?.Audiogetlanguage.filter(
          (key: any) => key?.textId === data?.blockId,
        );
        if (BlockTextFilter.length > 0) {
          const blockTextgetFiltered = BlockTextFilter.filter(
            (key: any) => key?.fieldName === 'blockText',
          );
          if (blockTextgetFiltered.length > 0) {
            const BlockTextContent = blockTextgetFiltered[0]?.content
              ? blockTextgetFiltered[0]?.content
              : null;
            setContentByLanguage(BlockTextContent);
          }
        }
        if (GameLanguageFilter.length > 0) {
          const NonPlayerGameFiltered = GameLanguageFilter.filter(
            (key: any) => key?.fieldName === 'gameNonPlayerName',
          );
          if (NonPlayerGameFiltered.length > 0) {
            const NonplayerName = NonPlayerGameFiltered[0]?.content
              ? NonPlayerGameFiltered[0]?.content
              : formData?.gameNonPlayerName;
            setNonPlayerNameLanguage(NonplayerName);
          }
        }
      } else {
        setContentByLanguage(data?.blockText);
      }
      if (Gameid) {
        const currentQuest = data
          ? parseInt(data?.blockPrimarySequence.split('.')[0])
          : null;
        setPreLogDatas((prev: any) => ({
          ...prev,
          lastActiveBlockSeq: { [currentQuest]: [data.blockId] },
        }));
        if (
          getPrevLogDatas?.nevigatedSeq &&
          getPrevLogDatas?.nevigatedSeq[currentQuest]
        ) {
          if (
            !getPrevLogDatas?.nevigatedSeq[currentQuest].includes(
              data.blockPrimarySequence,
            )
          ) {
            setPreLogDatas((prev: any) => ({
              ...prev,
              nevigatedSeq: {
                ...prev.nevigatedSeq,
                [currentQuest]: [
                  ...(prev.nevigatedSeq[currentQuest] || []),
                  data.blockPrimarySequence,
                ],
              },
            }));
          }
        } else {
          setPreLogDatas((prev: any) => ({
            ...prev,
            nevigatedSeq: {
              ...prev.nevigatedSeq,
              [currentQuest]: [data.blockPrimarySequence],
            },
          }));
        }
      }
      if (gameInfo.hasOwnProperty('blocks')) {
        let previousPrimarySeq = navTrack[navTrack.length - 1];
        if (previousPrimarySeq) {
          let currentQuest = previousPrimarySeq.split('.')[0];
          let previousBlock: any = Object.values(
            gameInfo?.blocks[currentQuest],
          )?.find((row: any) => {
            return row.blockPrimarySequence === previousPrimarySeq;
          });
          if (data.blockPrimarySequence !== previousPrimarySeq) {
            const newArray = navTrack;
            newArray.push(data.blockPrimarySequence);
            setNavTrack(newArray);
          }
        } else {
          setNavTrack([data.blockPrimarySequence]);
        }
      }
    }
  }, [data, type]);
  useEffect(() => {
    setFirst(true);
    setAnimateInteraction(false);
    setTimeout(() => {
      setFirst(false);
      setShowNote(false);
    }, 1000);
  }, []);
  useEffect(() => {
    if (animateInteraction === true) {
      setAnimateInteraction(false);
    }
  }, [animateInteraction]);

  const audioFiles = {

    IntroMusic: require("../../../../../../assets/adiuo/intromusicone.mp3"),
  };
    const musicRef = React.useRef(null);
  
     useEffect(() => {
      if (isLoading) {
        // 🎵 Play Bill’s music when loader starts
        musicRef.current = new Audio(audioFiles.IntroMusic);
        musicRef.current.loop = true; // optional looping
        musicRef.current.volume = 0.8; // optional volume control (0–1)
        musicRef.current.play().catch((err:any) => {
          console.warn("Autoplay blocked by browser:", err);
        });
      } else {
        // ⏹️ Stop music when loader ends
        if (musicRef.current) {
          musicRef.current.pause();
          musicRef.current.currentTime = 0;
        }
      }
  
      // 🧹 Cleanup on unmount
      return () => {
        if (musicRef.current) {
          musicRef.current.pause();
          musicRef.current.currentTime = 0;
        }
      };
    }, [isLoading]);
  
  const AudioDuration = (
    audio: any,
    audioUrl: any,
    gettype?: any,
    FindCurrentPlayingData?: any,
  ) => {
    audio.addEventListener('loadedmetadata', () => {
      const duration = audio.duration;

      let setWhospeaker: any = '';
      let setcharacteraction: any = '';
      if (
        !['response', 'feedback', 'Note'].includes(gettype) &&
        AudioOptions.qpOptionId === ''
      ) {
        setWhospeaker =
          FindCurrentPlayingData.blockRoll === '99999' ||
          FindCurrentPlayingData.blockRoll === 'Narrator'
            ? 'Narrator'
            : FindCurrentPlayingData.blockRoll === '999999'
            ? 'PC'
            : 'NPC';
        setcharacteraction =
          FindCurrentPlayingData?.blockCharacterposesId ?? '';
      } else if (['Note'].includes(gettype) && AudioOptions.qpOptionId === '') {
        setWhospeaker = 'Narrator';
        setcharacteraction = '';
      } else if (
        ['Interaction'].includes(gettype) &&
        AudioOptions.qpOptionId !== ''
      ) {
        setWhospeaker = 'PC';
        setcharacteraction = FindCurrentPlayingData?.qpEmotion ?? '';
      } else if (
        ['response'].includes(gettype) &&
        AudioOptions.qpOptionId !== ''
      ) {
        setWhospeaker =
          FindCurrentPlayingData.blockResponseRoll === '99999'
            ? 'Narrator'
            : FindCurrentPlayingData.blockResponseRoll === '999999'
            ? 'PC'
            : 'NPC';
        setcharacteraction = FindCurrentPlayingData?.qpResponseEmotion ?? '';
      } else if (
        ['feedback'].includes(gettype) &&
        AudioOptions.qpOptionId !== ''
      ) {
        setWhospeaker = 'Narrator';
        setcharacteraction = '';
      }
      SetGlbPlayingDetails({
        audioduration: duration,
        characteraction: setcharacteraction,
        whospeak: setWhospeaker,
      });
      URL.revokeObjectURL(audioUrl);
    });
  };
  useEffect(() => {
    const updateWidth = () => {
      const element = document.querySelector('.css-1at5wry');
      if (element instanceof HTMLElement) {
        const screenWidth = window.innerWidth;
        if (screenWidth >= 760 && screenWidth < 840) {
          element.style.width = 'calc(125vh - 35vh)';
        } else if (screenWidth >= 640 && screenWidth < 760) {
          element.style.width = 'calc(110vh - 35vh)';
        } else {
          element.style.width = 'calc(126vh - 28vh)';
        }
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  const fetchData = async () => {
    if (profileData?.Audiogetlanguage.length !== 0) {
      const GameLanguageFilter = profileData?.Audiogetlanguage.filter(
        (key: any) => key?.textId === formData?.gameId,
      );
      const BlockTextFilter = profileData?.Audiogetlanguage.filter(
        (key: any) => key?.textId === data?.blockId,
      );
      if (BlockTextFilter.length > 0) {
        const blockTextgetFiltered = BlockTextFilter.filter(
          (key: any) => key?.fieldName === 'blockText',
        );
        if (blockTextgetFiltered.length > 0) {
          const BlockTextContent = blockTextgetFiltered[0]?.content;
          setContentByLanguage(BlockTextContent);
        }
      }
      if (GameLanguageFilter.length > 0) {
        const NonPlayerGameFiltered = GameLanguageFilter.filter(
          (key: any) => key?.fieldName === 'gameNonPlayerName',
        );
        if (NonPlayerGameFiltered.length > 0) {
          const NonplayerName = NonPlayerGameFiltered[0]?.content
            ? NonPlayerGameFiltered[0]?.content
            : formData?.gameNonPlayerName;
          setNonPlayerNameLanguage(NonplayerName);
        }
      }
      setAudioObj((prev: any) => ({
        ...prev,
        url: '',
        type: EnumType.VOICE,
        loop: false, // Voice doesn't loop
        autoplay: true, // Autoplay is disabled
      }));
      if (
        AudioOptions.qpOptionId === '' &&
        (type === 'Note' || type === 'Dialog' || type === 'Interaction')
      ) {
        const GetblocktextAudioFiltered = profileData?.Audiogetlanguage.filter(
          (key: any) => key?.textId === data?.blockId,
        );
        if (GetblocktextAudioFiltered.length > 0) {
          const FilteredFieldName = GetblocktextAudioFiltered.map(
            (item: any) => item.fieldName,
          );
          const Filteredcontent = GetblocktextAudioFiltered.map(
            (item: any) => item.content,
          );
          if (FilteredFieldName[0] === 'blockText') {
            try {
              const normalizedPath = GetblocktextAudioFiltered[0]?.audioUrls
                ? GetblocktextAudioFiltered[0]?.audioUrls
                : '';

              if (normalizedPath !== '') {
                const fullUrl = `${API_SERVER}${normalizedPath}`;
                const responseblockText = await fetch(fullUrl);
                if (responseblockText.ok) {
                  setAudioObj((prev: any) => ({
                    ...prev,
                    url: fullUrl,
                    type: EnumType.VOICE,
                    loop: false, // Voice doesn't loop
                    autoplay: true, // Autoplay is disabled
                  }));
                  const audioBlob = await responseblockText.blob();
                  const audioUrl = URL.createObjectURL(audioBlob);
                  const audio = new Audio(audioUrl);

                  SetGlbPlayingDetails({
                    audioduration: audio.duration,
                    characteraction: data.blockCharacterposesId,
                    whospeak:
                      data.blockRoll === '99999'
                        ? 'Narrator'
                        : data.blockRoll === '999999'
                        ? 'PC'
                        : 'NPC',
                  });
                }
              }
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        }
      } else {
        if (AudioOptions.qpOptionId) {
          const optionAudioFiltered = profileData?.Audiogetlanguage.filter(
            (key: any) => key?.textId === AudioOptions?.qpOptionId,
          );
          if (optionAudioFiltered.length > 0) {
            const getoptionsAudioFiltered = optionAudioFiltered.filter(
              (key: any) => key?.fieldName === 'qpOptionText',
            );
            const responseAudioFiltered = optionAudioFiltered.filter(
              (key: any) => key?.fieldName === 'qpResponse',
            );
            const FeedBackAudioFiltered = optionAudioFiltered.filter(
              (key: any) => key?.fieldName === 'qpFeedback',
            );
            if (type === 'Interaction') {
              if (getoptionsAudioFiltered.length > 0) {
                try {
                  const normalizedPath = getoptionsAudioFiltered[0]?.audioUrls
                    ? getoptionsAudioFiltered[0]?.audioUrls
                    : '';
                  if (normalizedPath !== '') {
                    const qpOptionTextUrl = `${API_SERVER}${normalizedPath}`;
                    const responseqpOptionText = await fetch(qpOptionTextUrl);
                    if (responseqpOptionText.ok) {
                      setAudioObj((prev: any) => ({
                        ...prev,
                        url: qpOptionTextUrl,
                        type: EnumType.VOICE,
                        // volume: '0.5',
                        loop: false,
                        autoplay: true,
                      }));
                    }
                  }
                } catch (error) {
                  console.error('Error fetching data:', error);
                }
              }
            } else if (type === 'response') {
              if (responseAudioFiltered.length > 0) {
                try {
                  const normalizedPath = responseAudioFiltered[0]?.audioUrls
                    ? responseAudioFiltered[0]?.audioUrls
                    : '';
                  if (normalizedPath !== '') {
                    const qRespOptionTextUrl = `${API_SERVER}${normalizedPath}`;
                    const responseqpOptionText = await fetch(
                      qRespOptionTextUrl,
                    );
                    if (responseqpOptionText.ok) {
                      setAudioObj((prev: any) => ({
                        ...prev,
                        url: qRespOptionTextUrl,
                        type: EnumType.VOICE,
                        loop: false,
                        autoplay: true,
                      }));
                    }
                  }
                } catch (error) {
                  console.error('Error fetching data:', error);
                }
              }
            } else if (type === 'feedback') {
              if (FeedBackAudioFiltered.length > 0) {
                try {
                  const normalizedPath = FeedBackAudioFiltered[0]?.audioUrls
                    ? FeedBackAudioFiltered[0]?.audioUrls
                    : '';
                  if (normalizedPath !== '') {
                    const qFeedTextUrl = `${API_SERVER}${normalizedPath}`;
                    const FeedBackOptionText = await fetch(qFeedTextUrl);
                    if (FeedBackOptionText.ok) {
                      setAudioObj((prev: any) => ({
                        ...prev,
                        url: qFeedTextUrl,
                        type: EnumType.VOICE,
                        // volume: '0.5',
                        loop: false,
                        autoplay: true,
                      }));
                    }
                  }
                } catch (error) {
                  console.error('Error fetching data:', error);
                }
              }
            }
          }
        }
      }
    } else {
      if (data && type) {
        if (
          ['Note', 'Dialog', 'Interaction'].includes(type) &&
          AudioOptions.qpOptionId === ''
        ) {
          if (data?.blockRoll !== '999999') {
            try {
              const normalizedPath = data?.blockAudioUrl
                ? data?.blockAudioUrl
                : '';
              if (normalizedPath !== '') {
                const fullUrl = `${API_SERVER}${normalizedPath}`;
                const responseblockText = await fetch(fullUrl);
                if (responseblockText.ok) {
                  setAudioObj((prev: any) => ({
                    ...prev,
                    url: fullUrl,
                    type: EnumType.VOICE,
                    loop: false, // Voice doesn't loop
                    autoplay: true, // Autoplay is disabled
                  }));
                  const audioBlob = await responseblockText.blob();
                  const audioUrl = URL.createObjectURL(audioBlob);
                  const audio = new Audio(audioUrl);
                  AudioDuration(audio, audioUrl, type, data);
                }
              }
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          } else {
            if (profileData && 'gender' in profileData) {
              if (['male', 'Others'].includes(profileData?.gender)) {
                try {
                  const normalizedPath = data?.blockAudioUrl
                    ? data?.blockAudioUrl
                    : '';
                  if (normalizedPath !== '') {
                    const fullUrl = `${API_SERVER}${normalizedPath}`;
                    const responseblockText = await fetch(fullUrl);
                    if (responseblockText.ok) {
                      setAudioObj((prev: any) => ({
                        ...prev,
                        url: fullUrl,
                        type: EnumType.VOICE,
                        loop: false, // Voice doesn't loop
                        autoplay: true, // Autoplay is disabled
                      }));
                      const audioBlob = await responseblockText.blob();
                      const audioUrl = URL.createObjectURL(audioBlob);
                      const audio = new Audio(audioUrl);
                      AudioDuration(audio, audioUrl, type, data);
                    }
                  }
                } catch (error) {
                  console.error('Error fetching data:', error);
                }
              } else if (profileData?.gender === 'female') {
                try {
                  const normalizedPath = data?.blockAudioUrlFemale
                    ? data?.blockAudioUrlFemale
                    : '';
                  if (normalizedPath !== '') {
                    const fullUrl = `${API_SERVER}${normalizedPath}`;
                    const responseblockText = await fetch(fullUrl);
                    if (responseblockText.ok) {
                      setAudioObj((prev: any) => ({
                        ...prev,
                        url: fullUrl,
                        type: EnumType.VOICE,
                        loop: false, // Voice doesn't loop
                        autoplay: true, // Autoplay is disabled
                      }));
                      const audioBlob = await responseblockText.blob();
                      const audioUrl = URL.createObjectURL(audioBlob);
                      const audio = new Audio(audioUrl);
                      AudioDuration(audio, audioUrl, type, data);
                    }
                  }
                } catch (error) {
                  console.error('Error fetching data:', error);
                }
              }
            }
          }
        } else if (AudioOptions.qpOptionId !== '') {
          const FindUrl = options?.filter(
            (item: any) => AudioOptions.qpOptionId === item?.qpOptionId,
          );
          if (FindUrl?.length > 0) {
            try {
              if (type === 'Interaction') {
                if (profileData && 'gender' in profileData) {
                  if (['male', 'Others'].includes(profileData?.gender)) {
                    const optionAudio = FindUrl[0]?.qbAudioUrl
                      ? FindUrl[0]?.qbAudioUrl
                      : '';
                    if (optionAudio !== '') {
                      const fullUrl = `${API_SERVER}${optionAudio}`;
                      const responseblockText = await fetch(fullUrl);
                      if (responseblockText.ok) {
                        setAudioObj((prev: any) => ({
                          ...prev,
                          url: fullUrl,
                          type: EnumType.VOICE,
                          loop: false, // Voice doesn't loop
                          autoplay: true, // Autoplay is disabled
                        }));
                        const audioBlob = await responseblockText.blob();
                        const audioUrl = URL.createObjectURL(audioBlob);
                        const audio = new Audio(audioUrl);

                        AudioDuration(audio, audioUrl, type, FindUrl[0]);
                      }
                    }
                  } else {
                    const optionAudio = FindUrl[0]?.qbAudioUrlFemale
                      ? FindUrl[0]?.qbAudioUrlFemale
                      : '';
                    if (optionAudio !== '') {
                      const fullUrl = `${API_SERVER}${optionAudio}`;
                      const responseblockText = await fetch(fullUrl);
                      if (responseblockText.ok) {
                        setAudioObj((prev: any) => ({
                          ...prev,
                          url: fullUrl,
                          type: EnumType.VOICE,
                          loop: false, // Voice doesn't loop
                          autoplay: true, // Autoplay is disabled
                        }));
                        const audioBlob = await responseblockText.blob();
                        const audioUrl = URL.createObjectURL(audioBlob);
                        const audio = new Audio(audioUrl);

                        AudioDuration(audio, audioUrl, type, FindUrl[0]);
                      }
                    }
                  }
                }
              } else if (type === 'response') {
                const optionResponseAudio = FindUrl[0]?.qbResponseAudioUrl
                  ? FindUrl[0]?.qbResponseAudioUrl
                  : '';
                if (optionResponseAudio !== '') {
                  const fullUrl = `${API_SERVER}${optionResponseAudio}`;
                  const responseblockText = await fetch(fullUrl);
                  if (responseblockText.ok) {
                    setAudioObj((prev: any) => ({
                      ...prev,
                      url: fullUrl,
                      type: EnumType.VOICE,
                      loop: false, // Voice doesn't loop
                      autoplay: true, // Autoplay is disabled
                    }));
                    const audioBlob = await responseblockText.blob();
                    const audioUrl = URL.createObjectURL(audioBlob);
                    const audio = new Audio(audioUrl);

                    AudioDuration(audio, audioUrl, type, FindUrl[0]);
                  }
                }
              } else if (type === 'feedback') {
                const optionFeedBackAudio = FindUrl[0]?.qbfeedbackAudioUrl
                  ? FindUrl[0]?.qbfeedbackAudioUrl
                  : '';
                if (optionFeedBackAudio !== '') {
                  const fullUrl = `${API_SERVER}${optionFeedBackAudio}`;
                  const responseblockText = await fetch(fullUrl);
                  if (responseblockText.ok) {
                    setAudioObj((prev: any) => ({
                      ...prev,
                      url: fullUrl,
                      type: EnumType.VOICE,
                      loop: false, // Voice doesn't loop
                      autoplay: true, // Autoplay is disabled
                    }));
                    const audioBlob = await responseblockText.blob();
                    const audioUrl = URL.createObjectURL(audioBlob);
                    const audio = new Audio(audioUrl);

                    AudioDuration(audio, audioUrl, type, FindUrl[0]);
                  }
                }
              }
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        }
      }
    }
  };
  useEffect(() => {
    if (modalLoaded === true && isLoading === false) {
      fetchData();
    }
  }, [data, type, AudioOptions, modalLoaded, isLoading]);
  useEffect(() => {
    if (modalLoaded === true && isLoading === false && isZoomComplete) {
      fetchData();
    }
  }, [data, type, AudioOptions, modalLoaded, isLoading, isZoomComplete]);

  const InteractionFunction = () => {
    setAnimateInteraction(true);
    setTimeout(() => {
      setIsGetsPlayAudioConfirmation(true);

      const currentDateTime = new Date();
      const day: String = String(currentDateTime.getDate()).padStart(2, '0');
      const month: String = String(currentDateTime.getMonth() + 1).padStart(
        2,
        '0',
      ); // Months are zero-based
      const year: String = String(currentDateTime.getFullYear());
      const currentDate = `${day}-${month}-${year}`;
      if (Object.keys(questState).length > 0) {
        if (questState[profile?.currentQuest] === 'Started') {
          setProfile((prev: any) => {
            const { seqId, score: newScore } = score;

            const index = prev.score.findIndex(
              (item: any) => item.seqId === seqId,
            );
            if (index !== -1) {
              const updatedScore = [...prev.score];
              updatedScore[index] = {
                ...updatedScore[index],
                score: Number(newScore || 0),
              };
              return { ...prev, score: updatedScore };
            } else {
              const newScoreArray = [
                ...prev.score,
                {
                  seqId: seqId,
                  score: Number(newScore || 0),
                  quest: parseInt(seqId.split('.')[0]),
                  scoreEarnedDate: currentDate,
                },
              ];
              return { ...prev, score: newScoreArray };
            }
          });
        } else {
          setProfile((prev: any) => {
            const { seqId, score: newScore } = score;
            const index = prev.replayScore.findIndex(
              (item: any) => item.seqId === seqId,
            );
            if (index !== -1) {
              const updatedScore = [...prev.replayScore];
              updatedScore[index] = {
                ...updatedScore[index],
                score: Number(newScore || 0),
              };
              return { ...prev, replayScore: updatedScore };
            } else {
              const newScoreArray = [
                ...prev.replayScore,
                {
                  seqId: seqId,
                  score: Number(newScore || 0),
                  quest: parseInt(seqId.split('.')[0]),
                  scoreEarnedDate: currentDate,
                },
              ];
              return { ...prev, replayScore: newScoreArray };
            }
          });
        }
      } else {
        setProfile((prev: any) => {
          const { seqId, score: newScore } = score;
          const index = prev.score.findIndex(
            (item: any) => item.seqId === seqId,
          );
          if (index !== -1) {
            const updatedScore = [...prev.score];
            updatedScore[index] = {
              ...updatedScore[index],
              score: Number(newScore || 0),
            };
            return { ...prev, score: updatedScore };
          } else {
            const newScoreArray = [
              ...prev.score,
              {
                seqId: seqId,
                score: Number(newScore || 0),
                quest: parseInt(seqId.split('.')[0]),
                scoreEarnedDate: currentDate,
              },
            ];

            return { ...prev, score: newScoreArray };
          }
        });
      }
      setInteractionNext(true);
    }, 600);
  };
  useEffect(() => {
    if (interactionNext === true) {
      setInteractionNext(false);
      getData(data);
    }
  }, [interactionNext]);
  // const optionClick = (item: any, ind: any) => {
  //   setScore({ seqId: item?.qpSequence, score: parseInt(item?.qpScore) });
  //   SetAudioOptions(item);
  //   handleValidate(item, ind);
  // };
  
  const optionClick = (item: any, ind: any) => {
  // Check if this is a repeat question
  if (RepeatSelectOption) {
    // Repeat question => do NOT update score
    console.log("Repeat question selected, skipping score update", item);
  } else {
    // First-time selection => update score
    setScore({
      seqId: item?.qpSequence,
      score: parseInt(item?.qpScore),
      selectedOptioncheck: item?.qpOptions,
    });
  }

  // Audio and validation still run regardless
  SetAudioOptions(item);
  handleValidate(item, ind);
};

  const Updatecontent = () => {
    if (!showTypingEffect) {
      setShowTypingEffect(true);
    }
    if (upComingBlockChoosen !== 'Dialog') {
      setAnimateDialog(true);
      setTimeout(() => {
        getData(data);
      }, 500);
    } else {
      getData(data);
    }
  };

  useEffect(() => {
    setAnimateNote(false);
    setAnimateDialog(false);
    setAnimateInteraction(false);
    setAnimateFeedback(false);
  }, [data, type, showTypingEffect, upComingBlockChoosen]);
  useEffect(() => {
    setShowGLB(false);
    setTimeout(() => {
      setShowGLB(true);
    }, 800);
  }, []);
  const getNoteNextData = () => {
    setAnimateNote(true);
    setTimeout(() => {
      setIsPrevNavigation(false);
      getData(data);
    }, 500);
  };
  const SkipContentForBackNavigation = () => {
    // Always enable typing effect if off
    if (!showTypingEffect) {
      setShowTypingEffect(true);
    }

    // Ensure LastModiPrevData is always called after click
    LastModiPrevData(data);
  };

  const upNext = () => {
    setAnimateFeedback(true);
    setTimeout(() => {
      getData(data);
    }, 500);
  };
  const parseSequence = (seq: any) => {
    return seq.split('.').map(Number);
  };
  const findPreviousSequence = (array: any, currentSeq: any) => {
    const parsedCurrentSeq = parseSequence(currentSeq);
    let previousSeq = null;
    if (array) {
      for (let obj of array) {
        const parsedSeq = parseSequence(obj.blockPrimarySequence);
        if (
          parsedSeq[0] === parsedCurrentSeq[0] &&
          parsedSeq[1] < parsedCurrentSeq[1]
        ) {
          if (
            !previousSeq ||
            parsedSeq[1] > parseSequence(previousSeq.blockPrimarySequence)[1]
          ) {
            previousSeq = obj;
          }
        }
      }
      return previousSeq;
    } else {
      return previousSeq;
    }
  };
  const blockPrimarySequenceParts = data?.blockPrimarySequence.split('.');
  const primaryKey = blockPrimarySequenceParts
    ? parseInt(blockPrimarySequenceParts[0])
    : null;
  const valuesArray =
    gameInfo.blocks && gameInfo.blocks[primaryKey]
      ? Object.values(gameInfo.blocks[primaryKey])
      : null;
  const previousSeqObj = findPreviousSequence(
    valuesArray,
    data?.blockPrimarySequence,
  );
  const checkInfo =
    primaryKey && gameInfo?.blocks && gameInfo?.blocks[primaryKey]
      ? Object.values(gameInfo?.blocks[primaryKey])?.some((item: any) => {
          return item?.blockPrimarySequence === data?.blockPrimarySequence;
        })
      : null;
  let CheckPreviousData = null;
  if (checkInfo) {
    CheckPreviousData = data?.blockPrimarySequence;
  } else {
    CheckPreviousData = previousSeqObj?.blockPrimarySequence;
  }
  const sequenceMatches =
    primaryKey !== null &&
    gameInfo.blocks.hasOwnProperty(primaryKey) &&
    CheckPreviousData ===
      gameInfo.blocks[primaryKey]?.['1']?.blockPrimarySequence;
  useEffect(() => {
    if (type === 'Note') {
      setBasedOnNDI('top center');
    }
    if (type === 'Dialog') {
      setBasedOnNDI('right bottom');
    }
    if (type === 'Interaction') {
      setBasedOnNDI('center bottom');
    }
  }, [type]);

  return (
    <>
      {optionalReplay && (
        <ReplayGame
          setOptionalReplay={setOptionalReplay}
          replayGame={replayGame}
          replayNextHandler={replayNextHandler}
          type={type}
          gameInfo={gameInfo}
          setType={setType}
          setData={setData}
          isOptionalReplay={isOptionalReplay}
          setisOptionalReplay={setisOptionalReplay}
          setisReplay={setisReplay}
          profilescore={profilescore}
          isReplay={isReplay}
          formData={gameInfo?.gameData}
          imageSrc={preloadedAssets.Replay}
          getData={getData}
          data={data}
          preloadedAssets={preloadedAssets}
        />
      )}
      <Box className="storyPart" backgroundPosition={basedOnNDI}>
        {isLoading && (
          <Box
            style={{
              zIndex: 999999,
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          >
            <InitialLoader />
          </Box>
        )}
        {!isLoading && (
          <>
           {data && type === 'Note' && (

                <Box
                  className="chapter_potrait"
                >
                  <Grid
                    templateColumns="repeat(1, 1fr)"
                    gap={4}
                    position="absolute"
                    top="52%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    className="story_note_grid"
                  >
                    <GridItem colSpan={1} position={'relative'}>
                      <motion.div
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: animateNote ? 0 : 1, scale: animateNote ? 0 : 1 }}
                        transition={{ duration: 0.5 }}
                      >
                        <Box display={'flex'} justifyContent={'center'}>
                          <Img
                            src={preloadedAssets.note}
                            className="story_note_image"
                            loading="lazy"
                          />

                          <Box className={'note_align'}>
                            <Text textAlign={'center'} className="note_title">
                              Note
                            </Text>
                          </Box>
                          <Box
                            className={'story_note_content'}
                          >
                            <Box w={'100%'} display={'flex'} justifyContent={'center'}>
                              <Box className={'story_note_block'}>
                                <Scrollbar>
                                  {/* <Text textAlign={'center'} letterSpacing={'normal'}>
                                    {contentByLanguage !== null
                                      ? contentByLanguage
                                      : data?.blockText}
                                  </Text> */}

                                  {/* <Box textAlign="center" letterSpacing="normal">
  {isFirstNote && (
    <Text mb={2} fontWeight="bold">
      Introduction
    </Text>
  )}
  {isLastNote && (
    <Text mb={2} fontWeight="bold">
     Key Learnings
    </Text>
  )}
  <Text>
    {contentByLanguage !== null ? contentByLanguage : data?.blockText}
  </Text>
</Box> */}
<Box textAlign="center" letterSpacing="normal">
  {/* {isFirstNote && (
    <Text mb={2} fontWeight="bold">
      Introduction
    </Text>
  )}
  {isLastNote && (
    <Text mb={2} fontWeight="bold">
      Key Learnings
    </Text>
  )} */}

  {(() => {
    const noteText = contentByLanguage !== null ? contentByLanguage : data?.blockText || '';
    const [heading, ...rest] = noteText.split('<h1>');
    const normalText = rest.join('<h1>');

    return (
      <Box>
        {/* Show heading if present */}
        {heading && (
          <Text mb={2}  >
            {heading}
          </Text>
        )}

        {/* Render the rest (allowing <br> to become actual line breaks) */}
        {normalText && (
          <Text
            fontSize="md"
            
            whiteSpace="pre-line"
            dangerouslySetInnerHTML={{ __html: normalText }}
          />
        )}
      </Box>
    );
  })()}
</Box>


                                </Scrollbar>
                              </Box>
                            </Box>
                            <Box
                              className='story_block_btns_box'
                            >
                              <Box className="story_block_btns" justifyContent={!sequenceMatches ? 'space-between' : 'center'}>
                                {!sequenceMatches && <Img
                                  src={preloadedAssets.left}
                                  className={'interaction_button'}
                                  onClick={() => LastModiPrevData(data)}
                                />}
                                <Img
                                  src={preloadedAssets.right}
                                  className={'interaction_button'}
                                  onClick={() => {
                                    getNoteNextData()
                                  }}
                                  height={sequenceMatches ? '9vh' : '7vh'}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </motion.div>
                    </GridItem>
                  </Grid>
                </Box>
              )}
            {/* {data && type === 'Note' && (
              <Box className="chapter_potrait">
                <Grid
                  templateColumns="repeat(1, 1fr)"
                  gap={4}
                  position="absolute"
                  top="52%"
                  left="50%"
                  transform="translate(-50%, -50%)"
                  className="story_note_grid"
                >
                  <GridItem colSpan={1} position={'relative'}>
                    <motion.div
                      initial={{ opacity: 0, scale: 0.5 }}
                      animate={{
                        opacity: animateNote ? 0 : 1,
                        scale: animateNote ? 0 : 1,
                      }}
                      transition={{ duration: 0.5 }}
                    >
                      <Box display={'flex'} justifyContent={'center'}>
                        <Img
                          src={preloadedAssets.note}
                          className="story_note_image"
                          loading="lazy"
                        />

                        <Box className={'note_align'}>
                          <Text textAlign={'center'} className="note_title">
                            Note
                          </Text>
                        </Box>
                        <Box className={'story_note_content'}>
                          <Box
                            w={'100%'}
                            display={'flex'}
                            justifyContent={'center'}
                          >
                            <Box className={'story_note_block'}>
                              <Scrollbar>
                                <Text
                                  textAlign={'center'}
                                  letterSpacing={'normal'}
                                >
                                  {contentByLanguage !== null
                                    ? contentByLanguage
                                    : data?.blockText}
                                </Text>
                              </Scrollbar>
                            </Box>
                          </Box>
                          <Box className="story_block_btns_box">
                            <Box
                              className="story_block_btns"
                              justifyContent={
                                !sequenceMatches ? 'space-between' : 'center'
                              }
                            >
                              {!sequenceMatches && (
                                <Img
                                  src={preloadedAssets.left}
                                  className={'interaction_button'}
                                  onClick={() => LastModiPrevData(data)}
                                />
                              )}
                              <Img
                                src={preloadedAssets.right}
                                className={'interaction_button'}
                                onClick={() => {
                                  getNoteNextData();
                                }}
                                height={sequenceMatches ? '9vh' : '7vh'}
                              />
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </motion.div>
                  </GridItem>
                </Grid>
              </Box>
            )} */}
            {data && (type === 'response' || type === 'Dialog') && (
              <Box className="chapter_potrait">
                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                  <Img
                    className={'dialogue_image animateDialog dialog-transition'}
                    src={preloadedAssets.dial}
                    bottom={animateDialog ? '-200px' : '0'}
                    // style={{ transition: ' none ' }}
                  />
                  <Box position={'relative'}>
                    <Box
                      position={'fixed'}
                      h={'auto'}
                      w={'30%'}
                      left={'5%'}
                      bottom={animateDialog ? '-200' : '11.5vw'}
                      className={'animateDialog title dialog-title'}
                    >
                      <Img
                        src={preloadedAssets.char}
                        w={'100%'}
                        height={'100%'}
                      />
                      <Box
                        position={'absolute'}
                        top={'31%'}
                        left={'25.5%'}
                        w={'48%'}
                        height={'42%'}
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        fontWeight={500}
                        textAlign={'center'}
                        fontFamily={'AtlantisText'}
                        color={'#312821'}
                        textTransform={'capitalize'}
                        className="character_name"
                      >
                        <Text
                          whiteSpace={'nowrap'}
                          overflow={'hidden'}
                          textOverflow={'ellipsis'}
                        >
                          {type === 'response'
                            ? data.blockResponseRoll === '99999'
                              ? 'Narrator'
                              : data.blockResponseRoll === '999999'
                              ? Gameid
                                ? getPrevLogDatas?.previewProfile?.name ||
                                  'player'
                                : profileData?.name || 'player'
                              : NonPlayerNameLanguage
                            : data.blockRoll === '99999'
                            ? 'Narrator'
                            : data.blockRoll === '999999'
                            ? Gameid
                              ? getPrevLogDatas?.previewProfile?.name ||
                                'player'
                              : profileData?.name || 'player'
                            : NonPlayerNameLanguage}
                        </Text>
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    className="dialogue_scroll animateDialog animate-dialog-transition"
                    bottom={animateDialog ? '-200px' : '16px'}
                  >
                    <Scrollbar width="100%" height="100%">
                      <Box className="kishore" paddingTop={'10px'}>
                        {type === 'response'
                          ? resMsg
                          : contentByLanguage || data?.blockText}
                      </Box>
                      {/* )} */}
                    </Scrollbar>
                  </Box>
                  <Box
                    display={'flex'}
                    position={'fixed'}
                    justifyContent={'space-between'}
                    w={'95%'}
                    bottom={animateDialog ? '-200px' : '0'}
                    className={'animateDialog animate-dialog-transition'}
                  >
                    {type === 'Dialog' && sequenceMatches ? (
                      <Img />
                    ) : (
                      <Img
                        src={preloadedAssets.left}
                        className="dialog_btn"
                        cursor={'pointer'}
                        onClick={() => {
                          SkipContentForBackNavigation();
                        }}
                      />
                    )}
                    <Img
                      className="dialog_btn"
                      src={preloadedAssets.right}
                      onClick={() => Updatecontent()}
                    />
                  </Box>
                </Box>
              </Box>
            )}
            {data && type === 'Link' && (
              <Box className="chapter_potrait">
                <Grid
                  templateColumns="repeat(1, 1fr)"
                  gap={4}
                  position="absolute"
                  top="52%"
                  left="50%"
                  width="80% !important"
                  transform="translate(-50%, -50%)"
                  className="story_note_grid"
                >
                  <GridItem colSpan={1} position={'relative'}>
                    <motion.div
                      initial={{ opacity: 0, scale: 0.5 }}
                      animate={{
                        opacity: animateNote ? 0 : 1,
                        scale: animateNote ? 0 : 1,
                      }}
                      transition={{ duration: 0.5 }}
                    >
                      <Box display={'flex'} justifyContent={'center'}>
                        <Img
                          src={preloadedAssets.Thankyou}
                          className="story_note_image"
                          loading="lazy"
                        />

                        <Box className={'url_align'}>
                          <Text textAlign={'center'} className="note_title">
                            Nugget
                          </Text>
                        </Box>
                        <Box className={'story_url_content'}>
                          <Box
                            display={'flex'}
                            justifyContent={'center'}
                            width={'100%'}
                          >
                            <Box className={'story_url_block'} width={'100%'}>
                              <Box textAlign="center" width={'100%'}>
                                {(() => {
                                  const Link =
                                    contentByLanguage || data?.blockText;

                                  const IframeContainer = ({
                                    children,
                                  }: {
                                    children: React.ReactNode;
                                  }) => (
                                    <Box
                                      className="url_box"
                                      w="90%"
                                      h={['56vh']}
                                      maxW="124vw"
                                      maxH="70vh"
                                      borderRadius="12px"
                                      overflow="hidden"
                                      mx="auto"
                                    >
                                      {children}
                                    </Box>
                                  );
                                  if (
                                    Link?.includes('youtube.com') ||
                                    Link?.includes('youtu.be')
                                  ) {
                                    const videoId = Link.includes('youtu.be')
                                      ? Link.split('youtu.be/')[1]
                                      : new URL(Link).searchParams.get('v');
                                    return (
                                      <IframeContainer>
                                        <iframe
                                          src={`https://www.youtube.com/embed/${videoId}`}
                                          //  src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&controls=1&showinfo=0`}
                                          // src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&iv_load_policy=3&showinfo=0&controls=1&fs=0`}
                                          // src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&iv_load_policy=3&controls=1&fs=0`}
                                          // src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&iv_load_policy=3&controls=0&fs=0`}

                                          width="100%"
                                          height="100%"
                                          title="YouTube video"
                                          style={{ border: 'none' }}
                                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                          allowFullScreen
                                        />
                                      </IframeContainer>
                                    );
                                  }
                                  if (Link?.includes('vimeo.com')) {
                                    const videoId = Link.split('/').pop();
                                    return (
                                      <IframeContainer>
                                        <iframe
                                          src={`https://player.vimeo.com/video/${videoId}`}
                                          width="100%"
                                          height="100%"
                                          title="Vimeo video"
                                          style={{ border: 'none' }}
                                          allow="autoplay; fullscreen; picture-in-picture"
                                          allowFullScreen
                                        />
                                      </IframeContainer>
                                    );
                                  }
                                  if (Link?.startsWith('http')) {
                                    return (
                                      <IframeContainer>
                                        <iframe
                                          className="iframe_url"
                                          src={Link}
                                          width="100%"
                                          height="100%"
                                          title="Website preview"
                                          style={{
                                            border: 'none',
                                            transform: 'scale(1)',
                                            transformOrigin: 'top left',
                                          }}
                                          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                                        />
                                      </IframeContainer>
                                    );
                                  }
                                  return (
                                    <Text
                                      textAlign="center"
                                      letterSpacing="normal"
                                    >
                                      {Link}
                                    </Text>
                                  );
                                })()}
                              </Box>
                            </Box>
                          </Box>
                          <Box className="story_url_block_btns_box">
                            <Box
                              className="story_blockurl_btns"
                              justifyContent={
                                !sequenceMatches ? 'space-between' : 'center'
                              }
                            >
                              {!sequenceMatches && (
                                <Img
                                  style={{ marginLeft: '-6% !important' }}
                                  src={preloadedAssets.left}
                                  className={'interaction_button_left'}
                                  onClick={() => LastModiPrevData(data)}
                                />
                              )}
                              <Img
                                src={preloadedAssets.right}
                                className={'interaction_button'}
                                onClick={() => {
                                  getNoteNextData();
                                }}
                                height={sequenceMatches ? '9vh' : '7vh'}
                              />
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </motion.div>
                  </GridItem>
                </Grid>
              </Box>
            )}

            {data && type === 'Interaction' && (
              <Interaction
                data={data}
                option={option}
                options={options}
                optionClick={optionClick}
                InteractionFunction={InteractionFunction}
                navTrack={navTrack}
                preloadedAssets={preloadedAssets}
                selectedPlayer={selectedPlayer}
                LastModiPrevData={LastModiPrevData}
                RepeatSelectOption={RepeatSelectOption}
                RepeatPrevOption={RepeatPrevOption}
                contentByLanguage={contentByLanguage}
                currentScreenId={2}
                animateInteraction={animateInteraction}
                gameInfo={gameInfo}
                profile={profile}
              />
            )}
            {data && type === 'feedback' && (
              <Box className="chapter_potrait">
                <Grid
                  templateColumns="repeat(1, 1fr)"
                  gap={4}
                  position="absolute"
                  top="50%"
                  left="50%"
                  transform="translate(-50%, -50%)"
                  w={'90%'}
                >
                  <GridItem colSpan={1} position={'relative'}>
                    <motion.div
                      initial={{ y: 800 }}
                      animate={{ y: animateFeedback ? -800 : 0 }}
                      transition={{ duration: 0.1, ease: 'easeOut' }}
                    >
                      <Box
                        w={'fit-content'}
                        display={'flex'}
                        position={'relative'}
                      >
                        <Img
                          src={preloadedAssets.feedi}
                          className="story_note_image"
                          loading="lazy"
                        />
                        <Box
                          position={'absolute'}
                          top={{ base: '5%', md: '6%' }}
                          className="story_feedback_content"
                        >
                          <Box
                            display={'flex'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            h={'100%'}
                          >
                            <Box
                              w={'90%'}
                              h={'70%'}
                              display={'flex'}
                              justifyContent={'center'}
                              position={'relative'}
                            >
                              <Img
                                src={preloadedAssets?.feedparch}
                                w={'auto'}
                                h={'100%'}
                              />
                              <Box
                                position={'absolute'}
                                top={{ base: '-7px', sm: '-7px', lg: '-15px' }}
                                width={'100%'}
                                h={'100%'}
                                display={'flex'}
                                flexDirection={'column'}
                                justifyContent={'center'}
                                alignItems={'center'}
                              >
                                <Box w={'70%'}>
                                  <Img
                                    src={preloadedAssets.on}
                                    h={'4vh'}
                                    w={'100%'}
                                  />
                                </Box>
                                <Scrollbar width="70%" height="65%">
                                  <Box
                                    w={'100%'}
                                    h={'auto'}
                                    overflow={'hidden'}
                                    className="feedback_content_text"
                                  >
                                    <Box display={'flex'} mt={'10px'}>
                                      <Img
                                        src={preloadedAssets.FB}
                                        h={'1em'}
                                        w={'1em'}
                                      />
                                      <Text textAlign={'justify'}>{feed}</Text>
                                    </Box>
                                  </Box>
                                </Scrollbar>
                              </Box>
                              <Box
                                w={'120%'}
                                mt={'20px'}
                                display={'flex'}
                                justifyContent={'space-between'}
                                cursor={'pointer'}
                                position={'absolute'}
                                bottom={'-8%'}
                              >
                                <Img
                                  src={preloadedAssets.left}
                                  className={'interaction_button'}
                                  onClick={() => {
                                    LastModiPrevData(data);
                                  }}
                                />
                                <Img
                                  src={preloadedAssets.right}
                                  className={'interaction_button'}
                                  onClick={() => upNext()}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </motion.div>
                  </GridItem>
                </Grid>
              </Box>
            )}
          </>
        )}
      </Box>
    </>
  );
};
export default Story;
function InitialLoader() {
  return (
    <>
      <Box
        className="Entire-Loader-story"
        style={{ zIndex: '99999999 !important' }}
      >
        <motion.div
          className="Entire-Loader-wrapper-story"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          style={{ zIndex: '999999999 !important', opacity: 1}}
        >
          <Img
            src={LoadImg}
            className="load"
            style={{ zIndex: '99999999 !important',opacity: 1 }}
          />
        </motion.div>
      </Box>
    </>
  );
}
